module.exports = __webpack_public_path__ + "static/media/Stock 6.22e62267.svg";